import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";



function FormulaPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="formula" />

    </>
  );
}

export default FormulaPhysTopics;